import { FormatterInput } from 'fullcalendar';
import { eAgendaTabs, eCalendarView } from './Calendar.enums';
import { tCalendarContext, tGenericOption } from './Calendar.types';

export const initialContext: tCalendarContext = {
  calendarRef: { current: null },
  events: [],
  currentDate: new Date(),
  currentDateTitle: '',
  setEvents: () => false,
  setCurrentDate: () => false,
  setCurrentDateTitle: () => false,
  onEventClick: () => false,
  onNavigate: () => false,
  onViewResourceTimeGridDay: () => false,
  onChangeDatepicker: () => false,
  onToggleDatepicker: () => false,
  selectedEvent: undefined,
  setSelectedEvent: () => false,
  onCreateEventSubmit: () => false,
  onCreateChatEventSubmit: () => false,
  onUpdateEventSubmit: () => false,
  onDeleteEventSubmit: () => false,
  onDatesSetUpdate: () => false,
  changeView: () => false,
  currentView: eCalendarView.LIST_DAY,
  showCreateEvent: false,
  setShowCreateEvent: () => false,
  showUpdateEvent: false,
  setShowUpdateEvent: () => false,
  showDeleteEvent: false,
  setShowDeleteEvent: () => false,
  showDeleteTemplate: false,
  setShowDeleteTemplate: () => false,
  templates: [],
  setTemplates: () => false,
  currentArg: null,
  setCurrentArg: () => false,
  sendEventReminder: async () => {
    return;
  },
  currentTab: eAgendaTabs.EVENTS,
  setCurrentTab: () => false,
  loading: false,
  setLoading: () => false,
  // Match the hook starting state: a consumer rendered outside CalendarProvider (tests,
  // Storybook) should see the skeleton branch by default rather than silently falling
  // through to FullCalendar with empty data.
  initialLoading: true,
  hasFetchedEvents: false,
  selectedTemplate: null,
  setSelectedTemplate: () => false,
};

export const durationOptions: tGenericOption<string>[] = [
  { value: '00:15:00', label: '15 mins' },
  { value: '00:30:00', label: '30 mins' },
  { value: '00:45:00', label: '45 mins' },
  { value: '01:00:00', label: '1 hora' },
  { value: '01:15:00', label: '1:15 horas' },
  { value: '01:30:00', label: '1:30 horas' },
  { value: '01:45:00', label: '1:45 horas' },
  { value: '02:00:00', label: '2 horas' },
  { value: '03:00:00', label: '3 horas' },
  { value: '04:00:00', label: '4 horas' },
  { value: '05:00:00', label: '5 horas' },
  { value: '06:00:00', label: '6 horas' },
  { value: '07:00:00', label: '7 horas' },
  { value: '08:00:00', label: '8 horas' },
];

export const reminderOptions: tGenericOption<number>[] = [
  { value: 10, label: '10 minutos' },
  { value: 20, label: '20 minutos' },
  { value: 30, label: '30 minutos' },
  { value: 40, label: '40 minutos' },
  { value: 50, label: '50 minutos' },
  { value: 60, label: '60 minutos' },
  { value: 70, label: '70 minutos' },
  { value: 80, label: '80 minutos' },
  { value: 90, label: '90 minutos' },
  { value: 100, label: '100 minutos' },
  { value: 110, label: '110 minutos' },
  { value: 120, label: '120 minutos' },
];

export const listViewTimeFormat: FormatterInput = {
  month: 'long',
  day: 'numeric',
  weekday: 'long',
  year: 'numeric',
  omitCommas: true,
};

export const allowedFieldsError = 'Este campo es requerido';
